import { Link } from 'react-router-dom';
import styled from '@emotion/styled';
import { useDispatch, useSelector } from 'react-redux';
import React, { useState, useEffect } from 'react';
import { Button, CardButton, Heading, Icon, ProjectCard, Text } from '../../common';
import PlusWhite from '../../images/plus-white.svg';
import PlusGreen from '../../images/plus-green.svg';
import GreenDropdown from '../../assets/images/green-dropdown.svg';
import { Dropdown } from '../../components/form';
import { REQUEST_WEBDASHBOARD_DATA } from '../../constants/dashboard/webDashboardConstants';
const SeeButton = styled(Button)`
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
  line-height: 1;

  .reverse {
    transform: rotate(-180deg);
  }
`;
const country = [
  { label: 'Select One ', value: 'see_all_countries' },
  { label: 'USA', value: 'US' },
  { label: 'Canada', value: 'CA' },
  { label: 'India', value: 'IN' },
  { label: 'Morocco', value: 'MA' },
  { label: 'UAE', value: 'AE' }
];

const SeeLess = () => (
  <>
    See less <img src={GreenDropdown} className="ml-2" />
  </>
);

const SeeMore = () => (
  <>
    See more <img src={GreenDropdown} className="ml-2 reverse" />
  </>
);

const ProjectsList = [
  {
    name: 'Vogue',
    progress: 1,
    url: '../../images/relaunch.png',
    stage: [
      {
        name: 'Setup',
        info: 'Overview',
        notification: 'Riya Rathod hasn’t added team members yet',
        progress: 25
      }
    ]
  },
  {
    name: 'Stay safe!',
    progress: 2,
    url: '../../images/diagnostic.png',
    stage: [
      {
        name: 'Recruit',
        info: '10/30 Respondents Recruited',
        notification: null,
        progress: 30
      },
      {
        name: 'Design',
        info: '1/2 Tasks Designed',
        notification: null,
        progress: 45
      }
    ]
  },
  {
    name: 'Buying online',
    progress: 4,
    url: '../../images/relaunch.png',
    stage: [
      {
        name: 'Field',
        info: 'In Progress',
        notification: 'Task 1 : 20/30',
        progress: 70
      }
    ]
  },
  {
    name: 'Vogue',
    progress: 5,
    progressStatus: true,
    url: '../../images/relaunch.png',
    stage: [
      {
        name: 'Setup',
        info: 'Overview',
        notification: 'Riya Rathod hasn’t added team members yet',
        progress: 25
      }
    ]
  }
];

const Options = [
  {
    value: 'project_name',
    label: 'Project Name'
  },
  {
    value: 'project_status',
    label: 'Project Status'
  },
  {
    value: 'ongoing_first',
    label: 'Ongoing First'
  },
  {
    value: 'complete_first',
    label: 'Complete First'
  }
];

export default function Projects() {
  const [visibleProjectsCount, setVisibleProjectsCount] = useState(2);
  const dispatch = useDispatch();
  const userId = useSelector(state => state.LoginReducer.userId);
  let [projectStatus, setprojectStatus] = useState();
  const [seefilterMore, setSeefilterMore] = useState(false);
  const [selectedCountry, setSelectedCountry] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  //const [searchOpen, setSearchOpen] = useState(false);

  // const handleCountryChange = (selectedOption) =>{
  // 	setSelectedCountry(selectedOption);
  // 	console.log("Selected country :", selectedOption);
  // }
  const handleRemoveFilters = () => {
    setSelectedCountry([]);
  };
  // const handleCountryChange=(selectedOption)=>{
  // 	if(selectedOption[0]==="see_all_countries"){
  // 		setSelectedCountry([]);
  // 	}else{
  // 		setSelectedCountry(selectedOption)
  // 	}
  // };
  const handleCountryChange = selectedOption => {
    if (selectedOption.value === 'see_all_countries') {
      setVisibleProjectsCount(2);
      setTimeout(() => {
        handleRemoveFilters();
      }, 0);
    } else {
      setVisibleProjectsCount(2);
      setSelectedCountry(selectedOption);
    }
  };
  // const handleRemoveFilters=() =>{
  // 	setSelectedCountry([]);
  // }
  useEffect(() => {
    dispatch({
      type: REQUEST_WEBDASHBOARD_DATA,
      payload: {
        user_ID: userId
      }
    });
  }, []);
  projectStatus = useSelector(state => state.webDashboardReducer.projectStatus);

  const projectStatus1 = projectStatus;

  const handleChange = evt => {
    setVisibleProjectsCount(2);
    setprojectStatus();
    console.log(evt.value);
    projectStatus.map((stage, index) => {
      console.log('stage', stage.steps_array[stage.steps_array.length - 1].stepStatus);
    });
    if (evt.value == 'project_name') {
      console.log(evt.value);
      const sortedArr = projectStatus.sort((a, b) =>
        a.title.toUpperCase().localeCompare(b.title.toUpperCase(), 'de', { sensitivity: 'base' })
      );
      setprojectStatus(sortedArr);
    } else if (evt.value == 'ongoing_first') {
      console.log(evt.value);
      const sortedArr = projectStatus.sort(
        (a, b) => a.steps_array[a.steps_array.length - 1].Step - b.steps_array[b.steps_array.length - 1].Step
      );
      console.log('sortedArr', sortedArr);
      setprojectStatus(sortedArr);
    } else if (evt.value == 'complete_first') {
      console.log(evt.value);
      console.log('projectStatus', projectStatus);
      const sortedArr = projectStatus.sort(
        (a, b) => b.steps_array[b.steps_array.length - 1].Step - a.steps_array[a.steps_array.length - 1].Step
      );
      console.log('sortedArr', sortedArr);
      setprojectStatus(sortedArr);
    } else {
      console.log('gfgkhf', projectStatus1);
      setprojectStatus(projectStatus1);
    }

    console.log('sortedArr', projectStatus);
    setSeefilterMore(!seefilterMore);
    // console.log("1",projectStatus.sort((a, b) => a.title.localeCompare(b.titlle)));
  };

  useEffect(() => {
    handleRemoveFilters();
  }, [projectStatus, projectStatus1]);

  const filteredProjects = projectStatus
    ? (selectedCountry.length === 0
        ? projectStatus
        : projectStatus.filter(project => project.country_code === selectedCountry.value)
      ).filter(project => {
        if (searchTerm === '') {
          return true;
        }
        const searchTerms = searchTerm.toLowerCase().trim().split(/\s+/).filter(term => term.length > 0);
        if (searchTerms.length === 0) return true;
        
        const titleWords = (project.title || '').toLowerCase().split(/\s+/).filter(word => word.length > 0);
        
        return searchTerms.every(searchWord =>
          titleWords.some(titleWord => titleWord.startsWith(searchWord))
        );
      })
    : [];

  const visibleProjects = filteredProjects.slice(0, visibleProjectsCount);
  const hasMoreProjects = filteredProjects.length > visibleProjectsCount;
  const showSeeLess = visibleProjectsCount > 2 && !hasMoreProjects;

  return (
    <>
      <div className="row">
        <div className="col-md-9">
          <div className="d-flex align-items-start justify-content-start">
            <Link to="/" className="mt-1">
              <Button simple className="pr-0 pl-0">
                <Icon
                  color="var(--primaryColor)"
                  style={{
                    fontSize: '3rem',
                    lineHeight: '1'
                  }}
                >
                  keyboard_arrow_left
                </Icon>
              </Button>
            </Link>
            <div className="mt-3">
              <Heading className="d-flex align-items-center">Projects</Heading>
              <Text type="3">List of all the projects, ongoing and completed, your team has been a part of</Text>
            </div>
          </div>
        </div>
        <div className="col-md-3 d-flex justify-content-end">
          <Link to="/project/create">
            <CardButton>
              <img src={PlusGreen} alt="Plus Green" className="plus-green" />{' '}
              <img src={PlusWhite} alt="Plus White" className="plus-white" /> Create a project
            </CardButton>
          </Link>
        </div>
      </div>

      <div className="projects-list mt-4">
        <div className="d-flex justify-content-end align-items-center mb-3">
          <Icon
            style={{
              fontSize: '1.5rem',
              marginRight: '8px',
              flexShrink: 0,
              color: '#999',
              marginLeft: 'auto'
            }}
          >
            search
          </Icon>
          <input
            type="text"
            value={searchTerm}
            onChange={(e) => {
              setVisibleProjectsCount(2);
              setSearchTerm(e.target.value);
            }}
            placeholder="Project Name"
            style={{
              border: 'none',
              borderBottom: '1px solid #e3e0e0',
              padding: '8px 0',
              fontSize: '0.875rem',
              fontWeight: '400',
              outline: 'none',
              color: '#666',
              backgroundColor: 'transparent',
              width: '1px',
              minWidth: '100px',
              fontFamily: 'inherit',
              marginRight: '5px'
            }}
          />
          <Text className="mr-2" type="1">
            Country
          </Text>
          <Dropdown
            isSearchable={true}
            defaultValue={country[0]}
            options={country}
            onChange={handleCountryChange}
            selectedFontSize="0.875rem"
            selectedFontWeight="400"
          />

          <Text className="mr-2" type="1" style={{ whiteSpace: 'nowrap' }}>
            Sort By
          </Text>
          <Dropdown
            selectedFontSize="0.875rem"
            options={Options}
            defaultValue={{
              value: 'project_status',
              label: 'Project Status'
            }}
            onChange={handleChange}
            selectedFontWeight="400"
          />
        </div>
        {/* {ProjectsList.map(
					
					
					
					(project, index) => (
					<ProjectCard
						key={index}
						className='mb-4'
						project={project}
					/>
				))} */}

        {visibleProjects.map((project, index) => {
          return <ProjectCard key={index} className="mb-4" project={project} />;
        })}
        {filteredProjects.length > 2 && (
          <SeeButton
            simple
            color="var(--primaryColor)"
            fontSize="0.875rem"
            fontWeight="500"
            onClick={() =>
              showSeeLess ? setVisibleProjectsCount(2) : setVisibleProjectsCount(prevCount => prevCount + 5)
            }
          >
            {showSeeLess ? SeeLess() : SeeMore()}
          </SeeButton>
        )}
      </div>
    </>
  );
}
